import { configureStore } from '@reduxjs/toolkit';
import authReducer from './Slices/AuthSlice';
import companyAdminReducer from './Slices/CompanyAdminSlices';
import messageCountReducer from './Slices/MessageCountSlice';
export const store = configureStore({
  reducer: {
    auth: authReducer,
     companyAdmin: companyAdminReducer,
     messageCount: messageCountReducer,
  },
});